import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../core/service/v2/abstractRepositoryV2';
import {ProductModel} from '../../../api/entity/product.model';

@Injectable()
export class ProductRepository extends AbstractRepositoryV2<ProductModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Product', serviceElementsFactory, injector);
    }
}
